import { useNavigate, useParams } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useMutation } from '@apollo/client';
import { UPDATE_TRIP_PROFILE_DESTINATION, GET_TRIP_PROFILE, GET_LAST_STEP } from '@queries/trip-profiles';
import { Nuts } from '@src/types/maps';

const useSelectHandler = () => {
  const { clientId, tripProfileId } = useParams();
  const navigate = useNavigate();
  const [updateTripProfile] = useMutation(UPDATE_TRIP_PROFILE_DESTINATION, {
    refetchQueries: [
      { query: GET_TRIP_PROFILE, variables: { id: tripProfileId } },
      { query: GET_LAST_STEP, variables: { id: tripProfileId } },
    ],
    awaitRefetchQueries: true,
  });

  const updateDestination = async ({ nutsId, nutsName, countryName }: Nuts) => {
    if (!tripProfileId) {
      Sentry.captureMessage('Missing trip profile id', { level: 'error' });
      return;
    }
    const tripProfile = {
      id: tripProfileId,
      destinationId: nutsId,
      destination: nutsName,
      country: countryName,
    };
    console.log('tripProfile', tripProfile);
    await updateTripProfile({
      variables: { tripProfile },
    });
  };

  const selectHandler = ({ nutsId, nutsName, countryName }: Nuts, lat?: number, lng?: number) => {
    if (!nutsName || !nutsId) {
      Sentry.captureMessage(`Missing nuts name [${nutsName}] or id [${nutsId}]`, { level: 'error' });
    }

    updateDestination({ nutsId, nutsName, countryName })
      .then(() => {
        if (lat !== undefined && lng !== undefined) {
          navigate(`/clients/${clientId}/trip-profiles/${tripProfileId}/selected`, {
            state: { latitude: lat, longitude: lng },
          });
        } else {
          navigate(`/clients/${clientId}/trip-profiles/${tripProfileId}/selected`);
        }
      })
      .catch((err) => {
        Sentry.captureMessage(`Error updating destination [${nutsName}] or id [${nutsId}] - ${err}`, {
          level: 'error',
        });
      });
  };

  return { selectHandler };
};

export { useSelectHandler };
